import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-note-box',
  templateUrl: './note-box.component.html',
  styleUrls: ['./note-box.component.scss'],
})
export class NoteBoxComponent implements OnInit {

  @Input() title: string;
  @Input() note: string;
  @Input() link: string;

  constructor() { }

  ngOnInit() {}

}
